var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointshoundMilesTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.534 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006080;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "more_ways_to_earn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.805,19.57,23.053,13.882a1.075,1.075,0,0,0-1.42,1.018V41.925a1.075,1.075,0,0,0,2.15,0V16.4l14.6,4.959V41.925a1.075,1.075,0,1,0,2.15,0V20.589A1.076,1.076,0,0,0,39.805,19.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.286,18.637a1.075,1.075,0,0,0-1.075,1.075V41.925a1.075,1.075,0,0,0,2.15,0V19.712A1.075,1.075,0,0,0,12.286,18.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.617,18.637a1.075,1.075,0,0,0-1.075,1.075V41.925a1.075,1.075,0,0,0,2.15,0V19.712A1.075,1.075,0,0,0,6.617,18.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.829,14.53a1.025,1.025,0,0,0-.128-.223.936.936,0,0,0-.068-.119l-8.1-9.275V1.075a1.075,1.075,0,1,0-2.15,0V4.912L.261,14.187a1.037,1.037,0,0,0-.127.221.856.856,0,0,0-.053.093,1.038,1.038,0,0,0-.068.338A.6.6,0,0,0,0,14.9v.036c0,.015,0,.03,0,.046V41.925a1.075,1.075,0,0,0,2.15,0V15.975h14.6v25.95a1.075,1.075,0,0,0,2.15,0V14.9a1,1,0,0,0-.04-.2A1.1,1.1,0,0,0,18.829,14.53ZM9.455,6.95l6.006,6.875H3.435Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.917,22.237a1.075,1.075,0,0,0-1.075,1.075V25.67a1.075,1.075,0,1,0,2.15,0V23.312A1.074,1.074,0,0,0,33.917,22.237Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.25,22.237a1.074,1.074,0,0,0-1.075,1.075V25.67a1.075,1.075,0,0,0,2.15,0V23.312A1.075,1.075,0,0,0,28.25,22.237Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.917,29a1.074,1.074,0,0,0-1.075,1.075v2.356a1.075,1.075,0,1,0,2.15,0V30.07A1.073,1.073,0,0,0,33.917,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.25,29a1.073,1.073,0,0,0-1.075,1.075v2.356a1.075,1.075,0,1,0,2.15,0V30.07A1.074,1.074,0,0,0,28.25,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.917,35.752a1.075,1.075,0,0,0-1.075,1.075v2.357a1.075,1.075,0,0,0,2.15,0V36.827A1.074,1.074,0,0,0,33.917,35.752Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.25,35.752a1.074,1.074,0,0,0-1.075,1.075v2.357a1.075,1.075,0,0,0,2.15,0V36.827A1.075,1.075,0,0,0,28.25,35.752Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointshoundMilesTeal);
export default __webpack_public_path__ + "static/media/pointshound_miles_teal.35c90bc473b20ab11b5b497da5f39d78.svg";
export { ForwardRef as ReactComponent };